import { studySession } from "./study-session"
import { update } from "./update"

export const diagnostic = {
  studySession,
  update,
}
